import { BaseContainerModel } from '../../../base-container.model';
import {bl_del_logistic_hub_hdr_RowClass, bl_del_logistic_hub_link_RowClass} from '../../../../dbschema';

export class DeliveryLogisticHubNetworkContainer extends BaseContainerModel {
    networkHdrs: bl_del_logistic_hub_hdr_RowClass[][] = [];
    networkLinks: bl_del_logistic_hub_link_RowClass[][] = [];
}
